
export const Politice = () => {
    return (
        <div className="polcie">
            <a href="/conditions-generales-de-vente-et-dutilisation" className="link" alt="polic">
                    Conditions générales de vente et d’utilisation du site
            </a>
        </div>
       
    )
}